import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { InvoicesService } from '../../../_services/invoices.service';
import { ParameterData } from '../../../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../_helpers/dataservice.service'
import { Invoice, Account, Debtor } from '../../../_models';
import { CustomerService } from '../../../_services';
import { currencysymbolPrefix } from '../../../_enums/debtordocumenttype';
import { AuthService } from '../../../_services/auth.service';
import { AppConfig } from '../../../_helpers/index';
import * as moment from 'moment';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { validateMinimumPaymentValue } from '../../form-validators/partial-payment-validator';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class PaymentInvoiceEditComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public buttonValidate = false;

  public invoicePublic_key: any;
  public cusAccountPublicKey_temp: Account[] = [];
  public cusAccountPublicKey_ntemp: Account[] = [];
  public cusDebtor: Debtor[] = [];
  public invoiceForm: FormGroup;
  submitted = false;
  due_datetime: any;
  auth0Profile: any;
  ddltotalCurrencySymbol: any[];
  ddlLatefeeCurrencySymbol: any[];
  name: string;
  isalertVisiable = false;
  statusValue: any;
  minDate: any;
  maxDate: any;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  invoiceid: any;
  total_invoice: any;

  // Variables that will be used to indicate the status of debts
  isOverdue: boolean;
  isVoided: boolean;
  isExpired: boolean;
  isReversed: boolean;
  isNew: boolean;

  // Variable that will send the currency value to the accordion to set the form.
  currencySymbolInput: any;

  public user_public_id: string;
  customerSearch: FormControl = new FormControl();
  filteredValue: ReplaySubject<Debtor[]> = new ReplaySubject<Debtor[]>(1);
  searching: boolean = false;
  noEntriesFoundLabel = "No results matched";
  DebtorName = "";
  kashioApplication: any;
  customerFilterData: any[] =[];
  debtorsPublicId: any;

  // Variable I use for invoice status in the setInvoiceDetails() function.
  status: string;

  // Variable to show if invoice editing fails
  isErrorVisible: boolean;
  statusError: string;

  // Variable to indicate whether the account is CORPORATE or PAYMENTS
  APP: string;

  today;
  isDueDatetimeEdit: boolean;
  changeDateTimeEdit: boolean = false;

  isInvoiceMinimumPaymentAvailable: boolean = false;

  private destroy$ = new Subject<void>();
  /** This is Constructor function which is used to initialize the class variables and objects;
  */
    constructor
        (
            private router: Router, private route: ActivatedRoute
            , private _fb: FormBuilder
            , private parameterData: ParameterData
            , private dataService: DataService
            , private invoicesService: InvoicesService
            , private customerService: CustomerService
            , private _currencysymbolPrefix: currencysymbolPrefix
            , private auth: AuthService
            , private spinnerService: Ng4LoadingSpinnerService
        ) {
        this.isalertVisiable = false;

        //this is used to get the Invoice key comes from service; if public key is empty then default key will be asigned.

        this.ddltotalCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
        this.ddlLatefeeCurrencySymbol = _currencysymbolPrefix.currencyPrefix;

        this.dataService.currentInvoicePublicKey
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe((data) => {
                this.invoicePublic_key = data;
            });

        this.InitialSetup();

        const now = new Date();
        const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.minDate = todayDate;

        const lastDate = new Date(2050, 11, 31);
        this.maxDate = lastDate;
    }

    InitialSetup() {
        this.invoiceForm = this._fb.group({
            invoice_id: new FormControl(""),
            metadata: this._fb.group({
                order_id: new FormControl(""),
                order_name: new FormControl("", Validators.required),
                order_description: new FormControl("", Validators.maxLength(250))
            }),
            debtor: this._fb.group({
                public_id: new FormControl("", Validators.required),
                external_id: new FormControl(""),
                name: new FormControl(""),
                phone: new FormControl(""),
                email: new FormControl(""),
                document_type: new FormControl(""),
                document_id: new FormControl(""),
            }),
            total: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, Validators.required)
            }),
            due_datetime: new FormControl(new Date()),
            late_fee: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, Validators.required)
            }),
            expiration_datetime: new FormControl(new Date()),
            creditor_account: this._fb.group({
                public_id: new FormControl("")
            }),
            fees: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, Validators.required)
            }),
            sub_total: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, Validators.required)
            }),
        });
    }

    ngOnInit() {

        this.APP = localStorage.getItem('application');
        this.spinnerService.show();
        var browserStorage;
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;

        if (browserStorage1 == null) {
            browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            } else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');
            }
        } else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }
  
        browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        this.kashioApplication = localStorage.getItem('application');
  
        this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
        
        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
  
            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        } else {
            this.offsetTimeZone = browserStorage.getItem('timezone');
            this.offsetMinutes = 0;
  
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }

        let params: any = this.route.snapshot.params;
        this.invoicePublic_key = params.id;

        setTimeout(() => {
            this.customerService.getCustomerAccountList(this.customer_public_id).pipe(
                takeUntil(this.destroy$)
            ).subscribe(data => {
                this.cusAccountPublicKey_temp = data;
                if (this.kashioApplication === "PAYOUTS") {
                    this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'PAYABLE'));
                } else {
                    this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));
                }
            });
        }, 500)

        this.today = moment(new Date()).format('YYYY/MM/DD');
        this.setInvoiceDetails();
        this.customerSearch
            .valueChanges
            .pipe(debounceTime(500), takeUntil(this.destroy$))
            .subscribe(() => {
                this.search();
            });
    }

    updateMinimumPaymentValidity() {
        this.invoiceForm.get('partial_payment.min_amount').updateValueAndValidity();
    }

    addDueDateTimeEventEdit(event) {
        if (event.value !== null) {
            const dueDatetimeSelected = (event.value).format('YYYY/MM/DD');
            const daysDifferenceEdit = moment(dueDatetimeSelected).diff(moment(this.today), 'days');

            if (Math.sign(daysDifferenceEdit) === -1) {
                this.isDueDatetimeEdit = false;
            } else {
                this.isDueDatetimeEdit = true;
            }
        } else {
            this.isDueDatetimeEdit = true;
        }
    }

    showButtons(): boolean {

        if(this.APP === 'CORPORATE') {
            return false;
        } else if ( this.status == 'VOIDED' ){
            return false;
        } else if ( this.status == 'EXPIRED' ){
            return false;
        } else if ( this.status == 'REVERSED' ){
            return false;
        } else {
            return true
        }
    }

    updateInvoiceForm(invoice: Invoice) {
        const due_datetime = this.convertGMTTime(invoice.due_datetime);
        this.invoiceForm.patchValue({
            invoice_id: invoice.invoice_id,
            metadata: {
                order_id: invoice.metadata.order_id,
                order_name: invoice.name,
                order_description: invoice.metadata.order_description,
            },
            debtor: {
                public_id: invoice.debtor.public_id,
            },
            total: {
                currency: invoice.total.currency,
                value: invoice.total.value,
            },
            due_datetime: new Date(due_datetime.replace(/-/g, "/")).toISOString(),
            late_fee: {
                currency: invoice.late_fee.currency,
                value: invoice.late_fee.value,
            },
            expiration_datetime: new Date(invoice.expiration_datetime.replace(/-/g, "/")).toISOString(),
            creditor_account: {
                public_id: invoice.creditor_account == undefined ? '' : invoice.creditor_account.public_id
            },
            fees: {
                currency: invoice.fees.currency,
                value: invoice.fees.value,
            },
            sub_total: {
                currency: invoice.sub_total.currency,
                value: invoice.sub_total.value,
            }
        });
    }

    addPartialPaymentFormControl(invoice: Invoice, isPartialPaymentActive: boolean) {
        const partialPaymentGroup = this._fb.group({
            currency: [invoice.total.currency, Validators.required],
            active: [isPartialPaymentActive]
        });
        
        this.invoiceForm.addControl('partial_payment', partialPaymentGroup);
        
        if (isPartialPaymentActive) {
            let minAmount = 0;
            if (invoice.metadata.partial_payment !== undefined && invoice.metadata.partial_payment.min_amount !== undefined) {
                minAmount = invoice.metadata.partial_payment.min_amount;
            }
            partialPaymentGroup.addControl('min_amount', this._fb.control(minAmount, [Validators.required, validateMinimumPaymentValue]));
            this.invoiceForm.get('partial_payment.min_amount').updateValueAndValidity();
            this.setTotalFormListener();
        }
        this.invoiceForm.controls['partial_payment'].get('currency').disable();
    }

    setSubtotalFormListener() {
        // When the "next" is completed, I make sure that in the "complete" I set the valueChanges
        // listener of the "sub_total" field.
        this.invoiceForm.get('sub_total.value').valueChanges
            .pipe(
                takeUntil(this.destroy$)
            ).subscribe({
                next: sub_total => {

                    // When the field is empty and has no value, any of these cases
                    // can result, so it is assigned the value 0
                    if (isNaN(parseInt(sub_total)) || !sub_total || sub_total == "") {
                        sub_total = 0;
                    }
                    sub_total = Number(sub_total);

                    // I obtain the values of late_ fee and fees and then with the value of sub_total I make the
                    // calculation and assign this new value to total.
                    const late_fee = this.invoiceForm.get('late_fee.value').value;
                    const fees = this.invoiceForm.get('fees.value').value;

                    // parseFloat() is used instead of parseInt() to handle decimals.
                    const result = parseFloat(sub_total) + parseFloat(late_fee) + parseFloat(fees);

                    this.invoiceForm.get('total.value').setValue(result);
                }
            });

        this.invoiceForm.get('sub_total.currency').valueChanges
            .pipe(
                takeUntil(this.destroy$)
            ).subscribe({
                next: sub_total => {
                    this.currencySymbolInput = sub_total;
                    this.invoiceForm.get('late_fee.currency').setValue(sub_total);
                    this.invoiceForm.get('fees.currency').setValue(sub_total);
                    this.invoiceForm.get('total.currency').setValue(sub_total);
                    this.invoiceForm.get('partial_payment.currency').setValue(sub_total);
                }
            });
    }

    setTotalFormListener() {
        this.invoiceForm.get('total.value').valueChanges.pipe(
            takeUntil(this.destroy$),
            tap(value => this.updateMinimumPaymentValidity())
        ).subscribe();
    }

    setInvoiceDetails() {
        if (this.invoicePublic_key != null && this.invoicePublic_key != 'invoice Key') {
            this.invoicesService.getInvoice(this.invoicePublic_key)
                .pipe(
                    takeUntil(this.destroy$)
                ).subscribe({
                    next: invoice => {
                        this.setDebtorValue(invoice.debtor.public_id, invoice.debtor.name)
                        this.setCreditorValue(invoice.creditor.public_id);
                        this.minDate = new Date(invoice.due_datetime.replace(/-/g, "/"));

                        // Variable especially to restrict the edit button to the CORPORATE account.
                        this.status = invoice.status;

                        // Functions that return a boolean value according to the invoice status
                        this.isOverdue = invoice.status === "OVERDUE";
                        this.isVoided = invoice.status === "VOIDED";
                        this.isExpired = invoice.status === "EXPIRED";
                        this.isReversed = invoice.status === "REVERSED";
                        this.isNew = invoice.status === "NEW";

                        this.setSubTotalForm();
                        this.setTotalForm();

                        this.name = invoice.name;
                        this.due_datetime = invoice.due_datetime;
                        this.invoiceid = invoice.invoice_id;
                        this.total_invoice = invoice.total;
                        console.log(invoice)
                        this.updateInvoiceForm(invoice);

                        let isPartialPaymentActive;

                        if (invoice.metadata.partial_payment !== undefined && invoice.metadata.partial_payment !== null && invoice.metadata.partial_payment.active !== undefined && invoice.metadata.partial_payment.active !== null) {
                            this.isInvoiceMinimumPaymentAvailable = true;
                            isPartialPaymentActive = invoice.metadata.partial_payment.active;
                            this.addPartialPaymentFormControl(invoice, isPartialPaymentActive)
                        }

                        const dueDatetime = moment((invoice.due_datetime)).format('YYYY/MM/DD');
                        const daysDifference = moment(dueDatetime).diff(moment(this.today), 'days');
                        if (Math.sign(daysDifference) === 1 || Math.sign(daysDifference) === 0) {
                            this.isDueDatetimeEdit = true;
                        }
                    }, complete: () => {
                        this.setSubtotalFormListener();
                    }
                })
        }
    }

    async setDebtorValue(id, name) {
        this.debtorsPublicId = id;
        try {
            const data = await this.customerService.getCustomerListBySearch(this.customer_public_id, name).toPromise();
            this.customerFilterData = data.data;
            this.filteredValue.next(this.customerFilterData.filter(data => data.status == 'ACTIVE' || data.public_id == this.debtorsPublicId));
            this.searching = false;
            this.spinnerService.hide();
        }
        catch (error) {
            console.error('Failed while trying to get the customer list.' + error.error)
        }
    }

    setCreditorValue(id) {
        this.invoicesService.getInvoiceProperties(id)
                .pipe(
                    takeUntil(this.destroy$)
                ).subscribe({
                    next: data => {
                        const overdue = data.values["invoice.properties"].property_list.overdue;
                        if(data.status == 'ACTIVE' && overdue){
                            this.changeDateTimeEdit = true;
                        } else {
                            this.changeDateTimeEdit = false;
                        }
                    }
                })
    }

  async search() {
      if (this.customerSearch.value.length > 2) {
          this.invoiceForm.get('debtor.public_id').setValue('');
          this.searching = true;
          this.noEntriesFoundLabel = "No results matched " + '"' + this.customerSearch.value + '"';
          try {
              const data = await this.customerService.getCustomerListBySearch(this.customer_public_id, this.customerSearch.value).toPromise();
              this.customerFilterData = data.data;
              this.filteredValue.next(this.customerFilterData.filter(data => data.status == 'ACTIVE' || data.public_id == this.debtorsPublicId));
              this.searching = false;
          }
          catch (error) {
              console.error('Failed while trying to get the customer list.' + error.error)
          }
      }
  }

  ngOnDestroy() {
    this.dataService.changeinvoicepublicKey('invoice Key');
    this.destroy$.next();
    this.destroy$.complete();
}

  checkCurrencyDetails(value) {
      if (this.invoiceForm.get('total.currency').value != value) {
          alert("Please select the Currency same Mora and Monto")
      }
  }

    enableSaveButton() {
        this.isalertVisiable = false;
        this.buttonValidate = false;
    }

    enableSaveButtonExp() {
        this.isalertVisiable = false;
        this.buttonValidate = false;
    }

    setSubTotalForm() {
        if ((this.APP === 'CORPORATE') || (this.isVoided || this.isExpired || this.isReversed)) {
            this.invoiceForm.controls['sub_total'].disable();
        }
    }

    setTotalForm() {
        if ((this.APP === 'CORPORATE') || (this.isNew || this.isOverdue || this.isReversed || this.isVoided || this.isExpired)) {
            this.invoiceForm.controls['total'].disable();
        }
    }

    // Function that receives the values emitted from the Output() of the accordion.
    setDataForm(data: any) {

        // When the field is empty and has no value is assigned the value 0
        if (isNaN(parseFloat(data.late_fee.value))) {
            data.late_fee.value = 0;
        } else if (isNaN(parseFloat(data.fees.value))) {
            data.fees.value = 0;
        }

        // Whether the Output data is modified to 0 or not, these values are assigned
        //  to the fields of the form
        this.invoiceForm.get('late_fee.currency').setValue(data.late_fee.currency);
        this.invoiceForm.get('late_fee.value').setValue(data.late_fee.value);

        this.invoiceForm.get('fees.currency').setValue(data.fees.currency);
        this.invoiceForm.get('fees.value').setValue(data.fees.value);

        // When the field is empty and has no value, any of these cases
        // can result, so it is assigned the value 0
        let sub_total = this.invoiceForm.get('sub_total.value').value;
        if (isNaN(parseFloat(sub_total)) || !sub_total || sub_total == "") {
            sub_total = 0;
        }

        sub_total = Number(sub_total);

        // I obtain the values of late_ fee and fees and then with the value of sub_total I make the
        // calculation and assign this new value to total.
        // parseFloat() is used instead of parseInt() to handle decimals.
        const result = parseFloat(sub_total) + parseFloat(data.late_fee.value) + parseFloat(data.fees.value);
        this.invoiceForm.get('total.value').setValue(result);
    }

    setNewInvoiceForm(value) {
        let { partial_payment, metadata, ...invoiceObj } = value;
        let { currency, ...partialPaymentObj } = partial_payment;
        let newMetadata = { ...metadata, partial_payment: partialPaymentObj};
        return { ...invoiceObj, metadata: newMetadata };
    }

    onsubmit(invoiceForm: FormGroup) {
        let value  = invoiceForm.getRawValue();
        this.spinnerService.show();
        this.buttonValidate = true;

        this.cusAccountPublicKey_ntemp = this.cusAccountPublicKey_temp.filter((t => t.balance.currency == value.total.currency));

        value.creditor_account.public_id = this.cusAccountPublicKey_ntemp[0].public_id;

        const debtorInfo = this.customerFilterData.find(debtor => debtor.public_id === value.debtor.public_id);
        if (debtorInfo) {
            value.debtor.external_id = debtorInfo.external_id;
            value.debtor.name = debtorInfo.name;
            value.debtor.phone = debtorInfo.phone;
            value.debtor.email = debtorInfo.email;
            value.debtor.document_type = debtorInfo.document_type;
            value.debtor.document_id = debtorInfo.document_id;
        }
        var momentObj = moment(value.due_datetime);
        var dueDate = momentObj.format("YYYY-MM-DD 00:00:00");

        if(this.changeDateTimeEdit){
            value.due_datetime = dueDate;
        }else{
            let dueDateGMT = this.convertGMTTimeToSend(dueDate);
            value.due_datetime = dueDateGMT;
        }

        var dateObjexp = new Date(value.expiration_datetime);
        var momentObjexp = moment(dateObjexp);

        var expDate = momentObjexp.format('YYYY-MM-DD 00:00:00');
        let expDateGMT = this.convertGMTTime(expDate);
        
        value.expiration_datetime = expDateGMT;

        if (value.total.currency == 'S/.') {
            value.late_fee.currency = 'PEN';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'PEN';
            value.total.value = Number(value.total.value);
        }

        if (value.total.currency == 'US$') {
            value.late_fee.currency = 'USD';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'USD';
            value.total.value = Number(value.total.value);
        }

        value.total.value = Number(value.total.value);
        value.late_fee.value = Number(value.late_fee.value);

        if (value.id === null) {
            value.id = 0;
        }

        value.late_fee.currency = value.total.currency;

        // set payment_method propertie in metadata object with spread operator
        if (this.isInvoiceMinimumPaymentAvailable && value.partial_payment !== undefined) {
            value = this.setNewInvoiceForm(value);
        }

        if (this.invoicePublic_key != 'invoice Key') {
            if (value.total.currency == value.late_fee.currency) {
                this.invoicesService.updateInvoice(value, this.invoicePublic_key)
                    .pipe(
                        takeUntil(this.destroy$)
                    )
                    .subscribe({
                        next: result => {
                            if (typeof result == "string") {
                                this.statusError = result;
                                this.isErrorVisible = true;
                                this.spinnerService.hide();
                            } else {
                                this.statusValue = "La información fue creada correctamente !";
                                this.isalertVisiable = true;
                                this.spinnerService.hide();
                            }
                        }, error: err => {
                            // If invoice editing fails, code 400 will be generated, so the message will be assigned to "statusError" for rendering in the HTML
                            // and "isErrorVisible" will be set to true, complying with the *ngIf condition.
                            if (err.status == '400') {

                                this.statusError = err.error;

                                if (err.error.Description) {
                                    this.statusError = err.error.Description;
                                }

                                this.isErrorVisible = true;
                            };

                            this.spinnerService.hide();
                            console.error('Failed while trying to update the Invocie Details.' + err);
                        }
                    });
            } else {
                this.spinnerService.hide();
                this.statusValue = "Please select the Currency same Mora and Monto!";
                this.isalertVisiable = true;
            }
        }
    }

  /****GMT Converstion */
  convertGMTTime(convertDate) {
      var dateTimeZoneDiff = convertDate.split(/[- :]/),
          startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);

      if (this.offsetTimeZone > 0) {
          this.offsetMinutes = 30;
          var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
          var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);

          let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
          return tempDate;
      } else {
          this.offsetMinutes = 0;
          
          var startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() + Number(this.offsetTimeZone)));
          var startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));

          let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
          return tempDate1;
      }
    }

    convertGMTTimeToSend(convertDate) {
        var dateTimeZoneDiff = convertDate.split(/[- :]/),
            startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  
        if (this.offsetTimeZone > 0) {
            this.offsetMinutes = 30;
            var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
            var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);
  
            let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
            return tempDate;
        } else {
            this.offsetMinutes = 0;
            
            var startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() - Number(this.offsetTimeZone)));
            var startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));
  
            let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
            return tempDate1;
        }
      }

}
